import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  update: function (data) {
    return axios.put(`${window.apiURL}api/user`, data)
  },
  purchaseService: function (data) {
    return axios.post(`${window.apiURL}api/user/purchase-service`, data)
  },
  registerService: function (data) {
    return axios.post(`${window.apiURL}api/user/services`, data)
  },
  checkTutorial (name) {
    return axios.get(`${window.apiURL}api/user/tutorials/${name}`)
  },
  getRoyalties (artistId) {
    return axios.get(`${window.apiURL}api/user/royalties/${artistId}`)
  },
  getPayouts (artistId) {
    return axios.get(`${window.apiURL}api/user/payment_request/${artistId}`)
  },
  requestPayment (artistId) {
    return axios.post(`${window.apiURL}api/user/payment_request/${artistId}`)
  },
  getMonthDetails (artistId, year, month) {
    return axios.get(`${window.apiURL}api/user/royalties/${artistId}/${year}/${month}`)
  },
  subscribe: function (data) {
    return axios.post(`${window.apiURL}api/user/subscribe`, data)
  },
  getReferrals: function (data) {
    return axios.get(`${window.apiURL}api/user/referrals`)
  },
  getSubscription: function () {
    return axios.get(`${window.apiURL}api/user/subscription`)
  },
  cancelSubscription: function () {
    return axios.delete(`${window.apiURL}api/user/subscription`)
  },
  deactivateUser: function () {
    return axios.put(`${window.apiURL}api/user/deactivate`)
  },
  getCurrentStrikes: function (params) {
    return axios.get(`${window.apiURL}api/user/strikes`, { params })
  },
  saveStrikeAgree: function (userId) {
    return axios.put(`${window.apiURL}api/user/strikes`, userId)
  },
  getInstagramUser: function (username) {
    return axios.get(`${window.apiURL}api/instagram-search/${username}`)
  },
  getFacebookPage: function (username) {
    return axios.get(`${window.apiURL}api/facebook-search/${username}`)
  },
  sendProFeedback: function (data) {
    return axios.post(`${window.apiURL}api/user/pro-feedback`, data)
  },
  getEmbassyReferred: function () {
    return axios.get(`${window.apiURL}api/user/embassy-referred`)
  },
  sendChurnFeedback: function (reasons) {
    return axios.post(`${window.apiURL}api/user/churn-feedback`, reasons)
  },
  getStatements: function (params) {
    return axios.get(`${window.apiURL}api/user/statements`, { params })
  },
  getStatementArtists: function (params) {
    return axios.get(`${window.apiURL}api/user/statement-artists`, { params })
  },
  getBalance: function (artist) {
    return axios.get(`${window.apiURL}api/user/balance`, { params: { artist } })
  },
  getInsights: function (artist, artistId) {
    return axios.get(`${window.apiURL}api/user/insights`, { params: { artist, artist_id: artistId } })
  },
  getStripeLogin: function (stripeId) {
    return axios.get(`${window.apiURL}api/user/get-stripe-login`, { params: { stripe_id: stripeId } })
  },
  saveTerms: function () {
    return axios.put(`${window.apiURL}api/user/save-term`)
  },
  getNow: function () {
    return axios.get(`${window.apiURL}api/user/now`)
  },
  getFirstSteps: function () {
    return axios.get(`${window.apiURL}api/user/first-steps`)
  },
  saveFirstSteps: function () {
    return axios.put(`${window.apiURL}api/user/first-steps`)
  },
  requestVerification: function () {
    return axios.put(`${window.apiURL}api/user/request-verification`)
  },
  activateProWeekend: function () {
    return axios.put(`${window.apiURL}api/user/activate-pro-weekend`)
  },
  getAlertBannerBeatport: function () {
    return axios.get(`${window.apiURL}api/user/alert-dsp-beatport`)
  },
  saveAlertBannerBeatport: function () {
    return axios.put(`${window.apiURL}api/user/alert-dsp-beatport`)
  },
  getUserHasNewPricing: function () {
    return axios.get(`${window.apiURL}api/user/has-new-pricing`)
  },
  setSubscriptionTrackingData: function (data) {
    return axios.post(`${window.apiURL}api/user/set-subscription-tracking`, data)
  },
  createVerificationToken: function () {
    return axios.post(`${window.apiURL}auth/identity-verification-token`)
  },
  validateLegalName: function (artist, name, lastName) {
    return axios.get(`${window.apiURL}api/user/validate-legal-name`, { params: { artist, name, last_name: lastName } })
  },
  validateUserEmail: function (email) {
    return axios.post(`${window.apiURL}api/user/registered-email`, { email })
  },
  getUpgradeLink: function (plan) {
    return axios.get(`${window.apiURL}api/user/get-upgrade-link?plan=${plan || ''}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/user.js